<template>
  <div :class="bem('group--child')">
    <!-- toggle -->
    <button :class="[bem('toggle'), { active }]" @click="toggleFilterDropdown">
      <span :class="bem('toggle--title')">
        {{ filterGroup.label }}
      </span>
      <span :class="['btn--toggle chevron', { active }]"></span>
    </button>
    <!-- dropdown -->
    <template v-if="active">
      <transition name="fade" mode="in-out">
        <div :class="bem('dropdown')" v-show="active">
          <div v-if="filterGroup.label == 'Size'" :class="bem('size--buttons')">
            <button
              type="button"
              :class="['collection-men-size', { selected: isMen }]"
              @click="selectedMen">
              US Men
            </button>
            <button
              type="button"
              :class="['collection-women-size', { selected: isWomen }]"
              @click="selectedWomen">
              US Women
            </button>
          </div>
          <div :class="[bem('dropdown--child'), filterGroup.label]">
            <div
              v-for="(option, index) in filterGroup.values"
              :key="index"
              @click="$emit('update', filterGroup, option.key)"
              :class="[
                bem('option'),
                {
                  'active-filter':
                    activeFilters[
                      `${filterGroup.filterOptionId}--${option.key}`
                    ],
                  hide: hideOption(option.key, filterGroup.label, index),
                },
              ]">
              <span
                :class="bem('swatch')"
                :style="
                  swatch(optionName(option.key, filterGroup.label))
                "></span>
              <span
                :class="bem('text')"
                v-text="optionName(option.key, filterGroup.label)"></span>
            </div>
          </div>
        </div>
      </transition>
    </template>
  </div>
</template>

<script>
export default {
  name: 'FilterGroup',

  props: ['idx', 'handle', 'filterGroup', 'activeFilters', 'swatches', 'activeBlock'],

  computed: {
    active() {
      if (this.$screen.tablet_m_up) {
        return this.toggled;
      }
      return this.$store.collectionActiveFilter === this.idx;
    },
  },

  data() {
    return {
      toggled: this.$screen.tablet_m_up,
      isMen: this.activeBlock?.size === 'men' || this.handle.includes('-men'),
      isWomen: this.activeBlock?.size === 'women' || (this.activeBlock?.size !== 'men' && !this.handle.includes('-men')),
      hideMen: false,
    };
  },

  methods: {
    optionName(name, prefix) {
      if (this.isMen && name.includes('M ')) {
        const menSize = name.split(' / ').shift().split('M ').pop();
        return (name = menSize);
      }
      if (this.isWomen && name.includes('/ W')) {
        const womenSize = name.split(' / ').pop().split('W ').pop();
        return (name = womenSize);
      }

      return name.replace(`${prefix}:`, '');
    },

    swatch(option) {
      const key = option.toLowerCase();
      if (this.swatches[key]?.image) {
        return `background-image: url(${this.swatches[key].image})`;
      }
      return `background: ${this.swatches[key]?.color ?? '#fff'}`;
    },

    toggleFilterDropdown() {
      this.toggled = !this.toggled;
      this.$actions.updateCollectionActiveFilter(this.idx);
    },

    selectedMen() {
      this.isMen = true;
      this.isWomen = false;
    },

    selectedWomen() {
      this.isWomen = true;
      this.isMen = false;
    },

    hideOption(option, label, index) {
      if (this.isWomen && label == 'Size' && !option.includes('/ W ')) {
        const hiddenOption = this.filterGroup.values[index];
        hiddenOption.hideMen = true;
        return 'hide';
      }
    },
  },
};
</script>
